module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"maintenanceNotice":"緊急メンテナンスにより更新が停止しております。"},"en":{"maintenanceNotice":"Updates are currently suspended due to emergency maintenance."}}')
  delete Component.options._Ctor
}
